import { render, staticRenderFns } from "./GiftManage.vue?vue&type=template&id=ea3cb9a8&scoped=true&"
import script from "./GiftManage.vue?vue&type=script&lang=js&"
export * from "./GiftManage.vue?vue&type=script&lang=js&"
import style0 from "./GiftManage.vue?vue&type=style&index=0&id=ea3cb9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3cb9a8",
  null
  
)

export default component.exports